

(function () {
    'use strict';
    angular.module('mso.directives')
        .directive('searchBox', searchBox);

    function searchBox() {
        var directive = {
            restrict: 'EA',
            template: require('/app/template/search-box.template.html').default,
            controller: searchBoxController,
            scope: {
                searchables: '=',
                selected: '=',
                showValidation: '=',
                requiredDataMissing: '=',
                searchBoxTitle: '=',
                removeOnSelect: '=',
                searchBoxId: '=',
                searchBoxName: '=',
                searchIcon: '=',
                placeholderText: '='
            }
        };

        searchBoxController.$inject = ['$scope', 'filterFilter'];
        return directive;

        function searchBoxController($scope, filterFilter) {
            if ($scope.searchIcon === undefined) {
                $scope.searchIcon = false;
            }
            setSelectedItemValue();
            $scope.getSearchResults = getSearchResults;
            $scope.selectItem = selectItem;
            $scope.populateDropDown = populateDropDown;
            $scope.getPlaceHolder = getPlaceHolder;
            $scope.itemsAvailableToSelect = itemsAvailableToSelect;

            function setSelectedItemValue() {
                if ($scope.searchables !== null && $scope.searchables !== undefined && $scope.searchables.length === 1) {
                    $scope.selectedItem = $scope.searchables[0].name;
                }
                else {
                    $scope.selectedItem = null;
                }
            }

            function populateDropDown() {
                $scope.isOpen = !$scope.isOpen;
                $scope.dropDownItems = $scope.searchables.filter(function (s) {
                    return s.selected !== true;
                });
            }

            function getPlaceHolder() {
                if ($scope.searchables == null || $scope.searchables == undefined) {
                    return "There are no items available";
                }

                if (itemsAvailableToSelect()) {
                    return $scope.placeholderText;
                }
                else {
                    return "There are no more items available";
                }
            }

            function itemsAvailableToSelect() {
                if ($scope.searchables === null || $scope.searchables === undefined) {
                    return false;
                }
                return $scope.searchables.filter(function (s) {
                    return s.selected !== true
                }).length > 0;
            }

            // Sorts items by their string name property
            function nameSorter(a, b) {
                return a.name.localeCompare(b.name);
            }

            function getSearchResults(searchValue) {
                // Filter the results by the search string passed in
                var results = filterFilter(angular.copy($scope.searchables), { name: searchValue });
                // Exclude any results where the item has its 'selected' property set to true
                return results.filter(function (r) {
                    return r.selected !== true;
                }).slice(0, 10);
            }

            function selectItem($item) {
                $scope.selected = $item;
                if ($scope.removeOnSelect !== undefined && $scope.removeOnSelect === true) {
                    $item.selected = true;
                    for (var i = 0; i < $scope.searchables.length; i++) {
                        if ($scope.searchables[i].name === $item.name) {
                            $scope.searchables[i].selected = true;
                            $scope.selectedItem = null;
                        }
                    }
                }

                else {
                    for (var i = 0; i < $scope.searchables.length; i++) {
                        if ($scope.searchables[i].name === $item.name) {
                            $scope.selectedItem = $scope.selected.name;
                        }
                    }
                }

                $scope.searchBoxForm.$setDirty();
                angular.forEach($scope, function (field) {
                    if (field !== null && field.$name !== undefined && field.$name === $scope.searchBoxName) {
                        field.$setDirty();
                    }
                });
            }

        }
    }
})();
